<template>
  <span v-if="statistics">
    <template v-if="isLessThanOneHour">
      {{ minutes }} {{ t('plural.minute', minutes) }}
    </template>

    <template v-else>
      {{ hours }} {{ t('plural.hour', hours) }}
    </template>
  </span>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from '@/vendors/i18n'

const { statistics } = defineProps({
  statistics: { type: Object, required: true }
})

const { t } = useI18n()

const isLessThanOneHour = computed(() => statistics?.is_less_than_one_hour)
const hours = computed(() => statistics?.to_hours)
const minutes = computed(() => statistics?.to_minutes)
</script>